module.exports = __webpack_public_path__ + "static/outside-drinks-9f8700dbc6e23cff8992921b5d05b038.png";